import { render, staticRenderFns } from "./CheckpointVersionHistoryPanel.vue?vue&type=template&id=4e9c1510&scoped=true"
import script from "./CheckpointVersionHistoryPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointVersionHistoryPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointVersionHistoryPanel.vue?vue&type=style&index=0&id=4e9c1510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c1510",
  null
  
)

export default component.exports